// src/ui/splash/BootSplash.tsx — boot splash (D-05, D-06, D-07, UI-SPEC §Boot Splash).
// Minimum 1.2s hold so the wordmark registers even on hot-cache loads, then
// 300ms fade-out before unmount. No loading indicator (D-06) — the splash
// itself is the loading indicator. Matches palette of gate screen so handoff
// is seamless.

import { useEffect, useState, type JSX } from 'react';

import '../shell.css';

const MIN_HOLD_MS = 1200; // D-07
const FADE_MS = 300; // UI-SPEC §Boot Splash

interface BootSplashProps {
  onDone(): void;
}

export function BootSplash({ onDone }: BootSplashProps): JSX.Element {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const holdTimer = setTimeout(() => setFading(true), MIN_HOLD_MS);
    return (): void => clearTimeout(holdTimer);
  }, []);

  useEffect(() => {
    if (!fading) return;
    const fadeTimer = setTimeout(() => onDone(), FADE_MS);
    return (): void => clearTimeout(fadeTimer);
  }, [fading, onDone]);

  return (
    <div
      className={`boot-splash${fading ? ' boot-splash--fading' : ''}`}
      data-testid="boot-splash"
      aria-live="polite"
    >
      <img
        className="boot-splash__vignette"
        src="/splash-placeholder.png"
        alt=""
        aria-hidden="true"
      />
      <h1 className="boot-splash__wordmark">Mouchao</h1>
    </div>
  );
}
